import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { WithdrawalCardModals } from "@/constants/enums";
import WithdrawalDetailsCard from "../WithdrawalDetailsCard";
import { useWeb3 } from "@/context/Web3Context";
import { propsWithdrawalModal } from "../props";
import { useTranslation } from "react-i18next";
import { FramerButton } from "../../common";

function MakeWithdrawalModal(props: propsWithdrawalModal) {
  // Props
  const {
    setActiveGroupedWithdrawals,
    groupedAvailableWithdrawals,
    setShowModal,
    setActiveTotalWithdrawalAmount,
    showModal,
  } = props;

  // Hooks
  const {
    connectWallet,
    isConnected,
  } = useWeb3();
  const { t } = useTranslation(["modals", "components", "common"]);

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setShowModal(WithdrawalCardModals.NoModal);
    }
  };

  return (
    <Dialog open={showModal === WithdrawalCardModals.MakeWithdrawal} onOpenChange={handleOpenChange}>
      <DialogContent
        className="px-6 md:min-w-3xl lg:min-w-5xl max-w-5xl max-h-[90vh] overflow-y-auto dark:bg-mfdarklight"
        data-cy="withdrawal-makewithdrawal-modal"
        onPointerDownOutside={(event) => {
          event.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle className="text-lg dark:text-white">
            {t("availablewithdrawals.title")}
          </DialogTitle>
        </DialogHeader>

        <div data-cy="withdrawal-makewithdrawal-modal" className="pt-3">
          {/* Connect wallet */}
          {!isConnected && (
            <div className="flex justify-between items-center my-4 space-x-2">
              <p className="text-sm font-semibold dark:text-white">
                {t("common:text.withdrawconnectwallet")}.
              </p>
              <FramerButton
                data-cy="withdrawal-connectwallet-button"
                className="bg-mforange text-white hover:bg-mforange/80"
                onClick={connectWallet}
              >
                {t("common:text.connectwallet")}
              </FramerButton>
            </div>
          )}
          {/* Card container */}
          <div className="space-y-4 max-h-[500px] overflow-y-auto">
            {groupedAvailableWithdrawals.length === 0 && (
              <p className="text-sm dark:text-white">
                {t("availablewithdrawals.noavailablewithdrawals")}
              </p>
            )}
            {/* SP withdrawal Card */}
            {
              groupedAvailableWithdrawals.map((groupedWithdrawals) => (
                <WithdrawalDetailsCard
                  key={`spWithdrawal:${groupedWithdrawals.investmentID}`}
                  groupedWithdrawals={groupedWithdrawals}
                  setShowModal={setShowModal}
                  setActiveGroupedWithdrawals={setActiveGroupedWithdrawals}
                  disabled={!isConnected}
                  setActiveTotalWithdrawalAmount={setActiveTotalWithdrawalAmount}
                />
              ))
            }
          </div>
        </div>

        <DialogFooter>
          <div className="flex w-full justify-start">
            <FramerButton
              data-cy="withdrawal-makewithdrawal-cancel-button"
              variant="outline-primary"
              className="mt-4"
              onClick={() => setShowModal(WithdrawalCardModals.NoModal)}
            >
              {t("common:buttons.cancel")}
            </FramerButton>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default MakeWithdrawalModal;
